<template>
	<skySelectCard class="draggableList">
		<template slot="header">
			<div>已选 {{ value.length }} 列</div>
			<el-link type="primary" @click="clear" :underline="false">清空已选</el-link>
		</template>
		<el-scrollbar>
			<draggable
				v-model="myArray"
				v-bind="dragOptions"
				@start="drag = true"
				@end="drag = false"
				filter=".forbid"
				:move="onMove"
				@change="onChange"
			>
				<transition-group type="transition" :name="!drag ? 'flip-list' : null">
					<skyAlert
						v-for="(x, index) in myArray"
						:key="x.columnCode"
						:class="{ forbid: x.parentCode == 'fixedPosition' }"
						:close="x.parentCode !== 'fixedPosition'"
						@close="onClose(index)"
					>
						<div slot="title">
							<i
								:class="[x.parentCode == 'fixedPosition' ? 'iconfont icon-a-bianzu311' : 'el-icon-rank']"
							></i>
							{{ x.columnName }}
						</div>
					</skyAlert>
				</transition-group>
			</draggable>
		</el-scrollbar>
	</skySelectCard>
</template>
<script>
import draggable from 'vuedraggable';
import skyAlert from '@/components/iglobalwin/formComponents/sky-alert.vue';
import skySelectCard from '@/components/iglobalwin/formComponents/sky-select-card.vue';
export default {
	name: 'draggableList',
	props: {
		defaultData: {
			type: Array,
			default: function () {
				return [];
			},
		},
		value: {
			type: Array,
			default: function () {
				return [];
			},
		},
		listSort: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		draggable,
		skyAlert,
		skySelectCard,
	},
	computed: {
		dragOptions() {
			return {
				animation: 200,
				group: 'people',
				disabled: false,
				ghostClass: 'sortable-ghost',
				chosenClass: 'chosenClass',
			};
		},
		myArray: {
			get() {
				return this.myArrayCopy.filter(item => item.check);
			},
			set(v) {
				if (
					!this.listSort ||
					this.myArrayCopy.length === 0 ||
					v.length === this.myArrayCopy.length
				) {
					/**
					 * this.listSort为false时，直接赋值
					 *
					 * this.myArrayCopy长度为零时，可不做处理的将传入的值赋给this.myArrayCopy
					 *
					 * this.myArrayCopy长度与传入的值的长度相等时，视为调整数据的排列顺序，直接赋值
					 */
					this.myArrayCopy = [...v];
				}
			},
		},
	},
	watch: {
		value: {
			handler(val) {
				this.myArray = val;
			},
			deep: true,
			immediate: true,
		},
	},
	data() {
		return {
			drag: false,
			myArrayCopy: [],
		};
	},
	methods: {
		onChange() {
			this.$emit('input', this.myArrayCopy);
		},
		onMove(e) {
			return e.relatedContext.element.parentCode !== 'fixedPosition';
		},
		onClose(index) {
			this.myArray[index].check = false;
			this.$nextTick(() => {
				this.$emit('input', this.myArray);
			});
		},
		clear() {
			this.myArray.forEach(item => {
				if (item.parentCode !== 'fixedPosition') {
					item.check = false;
				}
			});
			this.$nextTick(() => {
				this.$emit('input', this.myArray);
			});
		},
	},
};
</script>
<style lang="scss">
.draggableList {
	.select-card-title {
		padding: 10px 18px;
	}

	.iconfont,
	.el-icon-rank {
		color: #999999;
		margin-right: 5px;
		font-size: 16px;
	}

	.el-scrollbar__wrap {
		height: 532px;
	}
}
</style>
